import z from "zod";

import { type Env } from "../http/Env";
import { graphqlRequest } from "./graphqlRequest";

export interface MutationSavePageRequestOptions {
	pageID: string;
	canvasID: string;
	authorID: string;
	cells: unknown[];
	version: number;
	env: Env;
	fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
	authorizationHeader: string | undefined;
}

export function mutationSavePage({
	pageID,
	canvasID,
	authorID,
	cells,
	version,
	env,
	fetch,
	authorizationHeader,
}: MutationSavePageRequestOptions): Promise<MutationSavePageResponse> {
	return graphqlRequest({
		env,
		fetch,
		authorizationHeader,
		query: mutationSavePageOperation(pageID, canvasID, authorID, cells, version),
		responseSchema: mutationSavePageResponse,
		additionalHeaders: {
			"moment-operationName": "SavePage",
			"moment-pageID": pageID,
			"moment-version": version.toString(),
		},
	});
}

export type MutationSavePageResponse = z.infer<typeof mutationSavePageResponse>;
const mutationSavePageResponse = z.object({
	savePage: z.unknown(),
});

const mutationSavePageOperation = (
	pageID: string,
	canvasID: string,
	authorID: string,
	cells: unknown[],
	version: number
) => ({
	operationName: "SavePage",
	query: `
	mutation SavePage($page: SavePageInput!) {
		savePage(page: $page) {
			id
			slug
		}
	}`,
	variables: {
		page: {
			pageID,
			canvasID,
			cells,
			authorID,
			version,
		},
	},
});
